export const projects = [
  {
    id: 1,
    title: 'The Kick Within',
    client: 'Documentary',
    category: 'Documentary',
    year: '2025',
    duration: '10min',
    description: 'Linus grew up navigating a tough environment where the odds were rarely in his favor. Inside a Muay Thai gym, he found structure, focus, and a different path forward.',
    image: 'https://static.readdy.ai/image/1f9220bbbe9ef28e4ff27eb731024602/d5edf59731082cfcfedbdc35f3c90a93.png',
    videoUrl: 'https://www.youtube.com/embed/gxPaqkPOi5c?autoplay=1',
  },
  {
    id: 2,
    title: 'Puls',
    client: 'Short Film',
    category: 'Short Film',
    year: '2025',
    duration: '8min',
    description: 'Astrid navigates a series of moments that subtly challenge perception, revealing the nuances of her journey.',
    image: 'https://static.readdy.ai/image/1f9220bbbe9ef28e4ff27eb731024602/ff40d1b4aa72ced696b3047e56496858.png',
    videoUrl: 'https://www.youtube.com/embed/YjEFcQEfE3I?autoplay=1',
  },
];
